import { render, staticRenderFns } from "./img-head.vue?vue&type=template&id=03450023&scoped=true&"
import script from "./img-head.vue?vue&type=script&lang=js&"
export * from "./img-head.vue?vue&type=script&lang=js&"
import style0 from "./img-head.vue?vue&type=style&index=0&id=03450023&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03450023",
  null
  
)

export default component.exports